module.exports = (__webpack_require__(2))(41);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/PluginConfigBreadcrumbWidget.js from dll-reference girder_plugin_slicer_cli_web
// module id = 177
// module chunks = 0